import { Box, CircularProgress } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import type { FC } from "react";
import { useGetQuotationAllowedActions } from "../../../../../__generated__/orval/endpoints/quotations/quotations";
import { ObservationAttachmentsSection } from "./-internal_components/ObservationAttachmentsSection";

const RouteComponent: FC = () => {
  const { quotationId } = Route.useParams();
  const { data: allowedActions, isLoading } = useGetQuotationAllowedActions(
    Number(quotationId),
  );

  if (isLoading || !allowedActions) {
    return (
      <Box
        sx={{ alignItems: "center", display: "flex", justifyContent: "center" }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <ObservationAttachmentsSection
      canAddDocuments={allowedActions.can_add_observation_documents}
      canDeleteDocuments={allowedActions.can_delete_observation_documents}
      quotationId={Number(quotationId)}
    />
  );
};

export const Route = createFileRoute(
  "/_private/vbuyer/quotations/$quotationId/attachments",
)({
  component: RouteComponent,
});
